define('drops/numericInput/numericInput',[
    'jquery',
    'lq/drop',
    'lq/style',
    'jquery.numpadDecSeparator',
    'lq/util',
    'lq/constants',
    'lq/tooltip',
    'lq/numeric',
    'lq/required'
], function($, Drop, Style, numpadDecSeparator, util, constants, Tooltip, numeric, Required) {
    'use strict';

    var defaults = {
        data: {
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            changedDelay: 500
        }
    };

    function NumericInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.typeOfCurrentValue = constants.valueTypes.decimal;
    }

    Drop.extend(NumericInput, Drop);

    NumericInput.typeName = 'NumericInput';

    NumericInput.prototype.hasMaxValue = function() {
        return this.data.hasMaxValue || this.data.hasMaxLength;
    };

    NumericInput.prototype.hasMinValue = function () {
        return !!this.data.hasMinValue;
    };

    NumericInput.prototype.getMaxLength = function () {
        if (this.data.hasMaxLength)
            return this.data.maxLength;
        return this.data.maxValue.toString().length;
    };

    NumericInput.prototype.getMinValue = function () {
        return this.data.minValue;
    };

    NumericInput.prototype.getMaxValue = function () {
        if (this.data.hasMaxValue)
            return this.data.maxValue;
        return Math.pow(10, new Number(this.data.maxLength)) - 1;
    };

    NumericInput.prototype.updatePrefix = function() {
        if (this.data.prefix !== null || this.data.prefix !== '')
            this.$prefix.text(this.data.prefix);
        else
            this.$prefix.text('');
    };

    NumericInput.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$input);
    };

    NumericInput.prototype.createInput = function () {
        if (this.data.enableNumericKeypad === true) {
            var $numeric = $('<input type="number" />');

            if (this.hasMaxValue())
                $numeric.attr('max', this.getMaxValue());

            if (this.hasMinValue())
                $numeric.attr('min', this.getMinValue());

            return $numeric;
        }

        var inputType = this.data.maskedInput ? 'password' : 'text';  //type needs to be set before creating, because it cannot be changed
        var $input = $('<input type=' + inputType + ' />')
            .numericInput({
                maxValue: this.hasMaxValue() ? this.getMaxValue() : undefined,
                minValue: this.hasMinValue() ? this.getMinValue() : undefined,
                groupSeperator: this.formatter.groupSeperator,
                decimalSeperator: this.formatter.decimalSeperator
            })
            .numpadDecSeparator({
                separator: this.formatter.decimalSeperator
            });

        if (this.hasMaxValue())
            $input.attr('max', this.getMaxLength());

        return $input;
    };

    NumericInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        Required.prototype.addRemoveRequiredIndicator(this);

        this.$prefix = $('<span />')
            .css({
                'float': 'left',
                paddingRight: '4px',
                fontFamily: 'Verdana, Geneva, sans-serif',
                fontSize: '14px',
                lineHeight: '1'
            })
            .appendTo(this.$element);

        this.$span = $('<span />')
            .css({
                display: 'block',
                overflow: 'hidden'
            })
            .appendTo(this.$element);

        this.$input = this.createInput()
            .attr('name', this.data.name)
            .attr('tabindex', this.data.tabIndex)
            .attr('placeholder', this.data.watermark)
            .addClass('boxToBorderSize')
            .css({
                width: '100%',
                height: this.data.size.y + 'px'
            })
            .appendTo(this.$span);

        if (this.data.maskedInput) {
            this.addTogglePassword();
            this.changeOpenEyeIcon();
        } else {
            this.removeTogglePassword();
        }


        this.tooltip = new Tooltip(this, this.data.title, this.$input);
        this.tooltip.update();

        this.applyEventTrigger('focusLost', 'blur', this.$input);

        var self = this;
        var changedEvent = this.getEventDataFor('changed');
        if (changedEvent.enabled) {
            this.subscribeEventHandler(this.$input, 'keydown', function () {
                if (!_.has(self, 'lastChangedEventValue'))
                    self.lastChangedEventValue = self.getValue();
            });
            this.subscribeEventHandler(this.$input, 'keypress input', _.debounce(function () {
                if (self.lastChangedEventValue !== self.getValue()) {
                    self.lastChangedEventValue = self.getValue();
                    self.triggerEvent(changedEvent.raisedEventName);
                }
            }, this.data.changedDelay));
        }

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap',
                width: this.data.size.x + 'px',
                height: this.data.size.y + 'px'
            });

        this.renderStyles();

        this.$input.on('keyup', function (e) {
            self.cutDecimals();
            self.updateRequiredIndicator();

            if (e.keyCode === 13)
                self.triggerEventIfEnabled('enterPressed');
        });

        if (this.data.readOnly)
            this.$input.prop('readonly', true);

        this.updatePrefix();

        this.applyPosition();
    };

    NumericInput.prototype.focus = function () {
        this.$input.trigger('focus');
    };

    NumericInput.prototype.getDefaultEventArg = function () {
        return this.getValue();
    };

    NumericInput.prototype.getValue = function () {
        if (this.$input.val() === '')
            return null;

        // when using <input type="number"> we cannot control the formatting of numbers
        if (this.data.enableNumericKeypad === true)
            return this.$input.val();

        return this.formatter.convertToLicquidFormat(this.typeOfCurrentValue, this.$input.val());
    };

    NumericInput.prototype.clearValue = function () {
        this.$input.val('');
        this.updateRequiredIndicator();
        this.lastChangedEventValue = this.getValue();
    };

    NumericInput.prototype.setValue = function (update) {
        this.typeOfCurrentValue = update.type === constants.valueTypes.string ? constants.valueTypes.decimal : update.type;

        // when using <input type="number"> we cannot control the formatting of numbers
        if (this.data.enableNumericKeypad === true) {
            this.$input.val(update.value);
            this.lastChangedEventValue = update.value;
        } else {
            var text = this.formatter.convertFromLicquidFormat(this.typeOfCurrentValue, update.value);
            this.$input.val(text);
            this.lastChangedEventValue = this.getValue();
        }

        this.updateRequiredIndicator();
    };

    NumericInput.prototype.hasValue = function () {
        var value = this.getValue();

        if (value === undefined || value === null) {
            return false;
        }

        if (value.length === 0) {
            return false;
        }

        if ($.isNumeric(value)) {
            return true;
        }

        return false;
    };

    NumericInput.prototype.addTogglePassword = function () {
        var self = this;
        this.$togglePassword = $('<div class = "input-fa input-fa-eye">')
            .prop('title', 'Show password')
            .css({
                position: 'relative',
                top: '-50%',
                left: '-5px',
                marginTop: '-8px',
                float: 'right'
            })
            .on('click', function () {
                if (self.$input[0].type === "password") {
                    self.changeClosedEyeIcon();
                } else {
                    self.changeOpenEyeIcon();
                }
            })
            .appendTo(this.$element);
    };

    NumericInput.prototype.removeTogglePassword = function () {
        if (this.$togglePassword) {
            this.$togglePassword.remove();
            delete this.$togglePassword;
        }
    };

    NumericInput.prototype.getOpenEyeImagePath = function () {
        if (this.data.physicalFileOpenEye)
            return lq.getTenantUploads(this.data.physicalFileOpenEye);

        return null;
    };

    NumericInput.prototype.getClosedEyeImagePath = function () {
        if (this.data.physicalFileClosedEye)
            return lq.getTenantUploads(this.data.physicalFileClosedEye);

        return null;
    };

    NumericInput.prototype.changeOpenEyeIcon = function () {
        if (!this.$togglePassword) {
            this.addTogglePassword();
        }
        var type = 'open';
        var imagePath = this.getOpenEyeImagePath();
        if (imagePath && this.data.maskedInput && this.data.useCustomImage) {
            this.setCustomEyeImage(imagePath, type);
        } else if (this.data.maskedInput) {
            this.clearCustomEyeImage(type);
        }
        this.$input[0].type = "password";
    }

    NumericInput.prototype.changeClosedEyeIcon = function () {
        if (!this.$togglePassword) {
            this.addTogglePassword();
        }
        var type = 'closed';
        var imagePath = this.getClosedEyeImagePath();
        if (imagePath && this.data.maskedInput && this.data.useCustomImage) {
            this.setCustomEyeImage(imagePath, type);
        } else if (this.data.maskedInput) {
            this.clearCustomEyeImage(type);
        }

        this.$input[0].type = "text";
    }

    NumericInput.prototype.setCustomEyeImage = function (image, type) {
        this.$togglePassword
            .css({
                width: '16px',
                height: '16px',
                backgroundImage: 'url(' + require.toUrl(image) + ')',
                backgroundSize: '100% 100%'
            })
            .removeClass('input-fa-eye input-fa-eye-slash');

        if (type === 'closed') {
            $(this.$togglePassword)
                .prop('title', 'Hide password');
        }
        else if (type === 'open') {
            $(this.$togglePassword)
                .prop('title', 'Show password');
        }
    };

    NumericInput.prototype.clearCustomEyeImage = function (type) {
        $(this.$togglePassword)
            .css({
                width: '',
                height: '',
                backgroundImage: '',
                backgroundSize: ''
            });
        if (type === 'closed') {
            $(this.$togglePassword)
                .prop('title', 'Hide password')
                .addClass('input-fa-eye-slash')
                .removeClass('input-fa-eye');
        }
        else if (type === 'open') {
            $(this.$togglePassword)
                .prop('title', 'Show password')
                .addClass('input-fa-eye')
                .removeClass('input-fa-eye-slash');
        }
    };

    NumericInput.prototype.cutDecimals = function () {
        if (this.$input.val() && this.data.hasMaxDecimals) {
            var prec = parseInt(this.formatter.decimalPrecision);
            var splited = this.$input.val().split(this.formatter.decimalSeperator);
            if (typeof(prec) === 'number' && prec > -1) {
                if (splited.length > 1 && splited[1].length > prec) {
                    this.$input.val(splited[0] + this.formatter.decimalSeperator + splited[1].substring(0, prec));
                } else if (prec === 0) {
                    this.$input.val(splited[0]);
                }
            }
        }
    }

    return NumericInput;
});
